import React from 'react'
import Bottom from '../Bottom'
import Step1 from './step-1.png'
import Step2 from './step-2.png'
import Step3 from './step-3.png'
import './index.module.less'
export default () => {
  return <div styleName="container">
    <div styleName="banner"></div>
    <section styleName="steps">
      <h2>— 简单三步 即可使用 —</h2>
      <div styleName="step">
        <img src={Step1} alt="" />
        <div>
          <h3 styleName="step-title">1.下载希沃魔方APP</h3>
          <p styleName="step-content">点击按钮下载希沃魔方APP，并按步骤注册。</p>
        </div>
      </div>
      <div styleName="step">
        <img src={Step2} alt="" />
        <div>
          <h3 styleName="step-title">2.通过APP扫码绑定</h3>
          <p styleName="step-content">点击“我的设备”，即可扫码添加电子学生证。</p>
        </div>
      </div>
      <div styleName="step">
        <img src={Step3} alt="" />
        <div>
          <h3 styleName="step-title">3.添加成功</h3>
          <p styleName="step-content">成功添加电子学生证，开始你的家校互联之旅吧。</p>
        </div>
      </div>
    </section>
    <Bottom />
  </div>
}